/**
 * Price Per Portion / Untertext
 *
 * Metafelder:
 *   Variantenebene: custom.untertext_varianten  (überschreibt Produktebene)
 *   Produktebene:   custom.untertext_produkte    (Fallback)
 *
 * Timing-Problem: Empire's variant-change feuert beim Seitenload bereits
 * bevor unser defer-Script läuft. Lösung: dreifache Absicherung:
 *   1. variant-change Event direkt auf <variant-selection>
 *   2. MutationObserver auf das variant-Attribut (fängt auch nachträgliche Änderungen)
 *   3. Polling-Fallback: wartet bis Empire den initialen Fetch abgeschlossen hat
 */
(function () {
  'use strict';

  function extractPortions(text) {
    if (!text) return null;
    var match = text.match(/(\d+)\s*[Pp]ortion(?:en|s)?/i);
    return match ? parseInt(match[1], 10) : null;
  }

  function buildDisplay(untertext, priceInCents) {
    if (!untertext) return null;
    var portions = extractPortions(untertext);
    if (portions && priceInCents) {
      var perPortion = (priceInCents / portions / 100).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      return untertext + '\u00a0\u00b7\u00a0' + perPortion + '\u00a0\u20ac\u00a0/\u00a0Portion';
    }
    return untertext;
  }

  function initPricePerPortion(productDetailsEl) {
    var variantDataEl = productDetailsEl.querySelector('[data-price-per-portion-variants]');
    var displayEl     = productDetailsEl.querySelector('[data-price-per-portion]');
    var valueEl       = displayEl && displayEl.querySelector('[data-price-per-portion-value]');

    if (!variantDataEl || !displayEl || !valueEl) return;

    var variants;
    try {
      variants = JSON.parse(variantDataEl.textContent);
    } catch (e) {
      console.warn('[price-per-portion] JSON parse error', e);
      return;
    }

    var variantMap = {};
    variants.forEach(function (v) { variantMap[String(v.id)] = v; });

    function updateDisplay(variantId) {
      var variant = variantMap[String(variantId)];
      if (!variant || !variant.untertext) {
        displayEl.style.display = 'none';
        return;
      }
      var text = buildDisplay(variant.untertext, variant.price);
      if (!text) { displayEl.style.display = 'none'; return; }
      valueEl.textContent = text;
      displayEl.style.display = '';
    }

    var vsEl = productDetailsEl.querySelector('[data-variant-selection]');
    if (!vsEl) { displayEl.style.display = 'none'; return; }

    // 1. Event-Listener für Variantenwechsel
    vsEl.addEventListener('variant-change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (variant && variant.id) updateDisplay(variant.id);
      else displayEl.style.display = 'none';
    });

    // 2. MutationObserver: reagiert wenn Empire das variant-Attribut setzt/ändert
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'variant') {
          var id = vsEl.getAttribute('variant');
          if (id && id !== 'not-selected' && id !== 'unavailable') {
            updateDisplay(id);
          } else {
            displayEl.style.display = 'none';
          }
        }
      });
    });
    observer.observe(vsEl, { attributes: true, attributeFilter: ['variant'] });

    // 3. Initialer Render – Empire setzt variant-Attribut synchron in connectedCallback,
    //    aber _dispatchEvent ist async (wartet auf Fetch). Wir lesen das Attribut direkt.
    var initialId = vsEl.getAttribute('variant');
    if (initialId && initialId !== 'not-selected' && initialId !== 'unavailable') {
      updateDisplay(initialId);
    } else {
      // Noch nicht gesetzt – kurz warten bis connectedCallback durch ist
      setTimeout(function () {
        var id = vsEl.getAttribute('variant');
        if (id && id !== 'not-selected' && id !== 'unavailable') updateDisplay(id);
        else displayEl.style.display = 'none';
      }, 300);
    }

    // Fallback: native select (noscript)
    var variantSelect = productDetailsEl.querySelector('select[data-variants]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        updateDisplay(variantSelect.value);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-product-details]').forEach(initPricePerPortion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();